import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { smithersGlobalService } from "@/services/smithers-global-service"
import type { UpdateSmithersGlobalRequest } from "@/types/smithers-global"

export const SMITHERS_GLOBAL_KEY = ["smithers", "global"] as const
export function useSmithersGlobal() {
  return useSWR(SMITHERS_GLOBAL_KEY, () => smithersGlobalService.get(), { revalidateOnFocus: false, shouldRetryOnError: false })
}
export function useUpdateSmithersGlobal() {
  return useSWRMutation(SMITHERS_GLOBAL_KEY, (_key: typeof SMITHERS_GLOBAL_KEY, { arg }: { arg: UpdateSmithersGlobalRequest }) => smithersGlobalService.update(arg))
}
